var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoviherLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452.16 349.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5c5a7;}.cls-2{fill:#f8fef3;}.cls-3{fill:#144f4a;}.cls-4{fill:#f6ead5;}.cls-5{fill:#a29177;}.cls-6{fill:#c7b698;}.cls-7{fill:#c3b497;}.cls-8{fill:#e0f7f8;}.cls-9{fill:#9d8f6d;}.cls-10{fill:#155451;}.cls-11{fill:#c9ba97;}.cls-12{fill:#164b45;}.cls-13{fill:#148f91;}.cls-14{fill:#fdfef3;}.cls-15{fill:#0d4949;}.cls-16{fill:#cdc0a0;}.cls-17{fill:#bfb194;}.cls-18{fill:#bbad8f;}.cls-19{fill:#e4dec8;}.cls-20{fill:#f4e8d5;}.cls-21{fill:#f9e9c9;}.cls-22{fill:#beb295;}.cls-23{fill:#fffdf4;}.cls-24{fill:#c3b29b;}.cls-25{fill:#c8baa1;}.cls-26{fill:#f3e7ce;}.cls-27{fill:#dfceb0;}.cls-28{fill:#e0e0e0;}.cls-29{fill:#174d49;}.cls-30{fill:#fefdf6;}.cls-31{fill:#114b46;}.cls-32{fill:#c1af90;}.cls-33{fill:#15474e;}.cls-34{fill:#c2ae94;}.cls-35{fill:#d5c6a9;}.cls-36{fill:#fefff1;}.cls-37{fill:#fffcf5;}.cls-38{fill:#0c4e48;}.cls-39{fill:#154d46;}.cls-40{fill:#51acae;}.cls-41{fill:#c8b799;}.cls-42{fill:#f6e8ce;}.cls-43{fill:#28675d;}.cls-44{fill:#0f453d;}.cls-45{fill:#65b89f;}.cls-46{fill:#0f4d4b;}.cls-47{fill:#e4dcc7;}.cls-48{fill:#134f4a;}.cls-49{fill:#ddceb1;}.cls-50{fill:#144d48;}.cls-51{fill:#c7b594;}.cls-52{fill:#0f554e;}.cls-53{fill:#eedfc7;}.cls-54{fill:#107274;}.cls-55{fill:#aaa995;}.cls-56{fill:#f8e9d3;}.cls-57{fill:#175850;}.cls-58{fill:#134f48;}.cls-59{fill:#f3e4ce;}.cls-60{fill:#c6b394;}.cls-61{fill:#fffdf3;}.cls-62{fill:#f4e8d1;}.cls-63{fill:#f6e7d1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M0,264.67H15.45l18.89,39.29,20.14-39.29h15.7v84.43h-17.71v-42.21l-18,32.33-17.36-32.33v42.21H0v-84.43h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "146.17 264.67 164.44 264.67 178.95 316.96 193.21 264.67 211.87 264.67 187.12 348.67 171.57 348.67 146.17 264.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 218.42,
    y: 264.67,
    width: 17.36,
    height: 84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M247.53,264.67v84h17.36v-84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M262.21,298.44v18.64h31.91v-18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M290.42,264.93v83.74h17.74v-83.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M331.71,331.31v17.36h50.12v-17.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M320.89,264.67v84h18.17v-84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M338.34,297.48v19.6h31.74v-19.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M338.84,264.67v19.11h42.99v-19.11"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M131.04,271.11c-7.94-6.2-16.53-6.45-19.03-6.43-2.65-.06-10.12,.11-17.59,5.02-7.87,5.18-10.82,12.39-11.68,14.79v44.89c.81,2.52,2.71,7.2,7.09,11.58,5.35,5.35,11.37,7.2,14.05,7.85,6.35,1.54,11.64,.64,14.31,0,2.32-.28,9.25-1.4,15.36-7.07,5.76-5.35,7.39-11.6,7.88-13.89v-41.16c-.67-2.48-3.02-9.83-10.37-15.56l-.02-.02Zm-7.01,54.31c-.63,1.28-2.04,3.69-4.79,5.6-1.77,1.23-3.47,1.82-4.66,2.12l-7.21,.06c-1.13-.43-2.98-1.31-4.79-3.02-1.85-1.76-2.83-3.63-3.32-4.76v-36.53c.63-1.28,2.04-3.69,4.79-5.6,1.77-1.23,3.47-1.82,4.66-2.12l7.21-.06c1.13,.43,2.98,1.31,4.79,3.02,1.85,1.76,2.83,3.63,3.32,4.76v36.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M431.6,315.87c1.41-.12,9.32-.93,14.62-7.72,3.4-4.35,4-8.96,4.14-10.93v-8.75c-.01-2.28-.35-8.27-4.53-14.02-5.92-8.16-15-9.55-16.69-9.78h-37.12v84h17.2v-30.36h4.66l19.01,30.36h19.27c-6.86-10.93-13.71-21.87-20.57-32.8h.01Zm-5.81-14.43v.13h-17.24v-18.64h17.24v.06c4.85,1.7,7.99,5.24,8.04,9.12,.06,3.96-3.1,7.6-8.04,9.33h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "106.91 9.06 140.49 0 140.49 36.26 124.66 39.57 124.66 251.26 106.78 251.26 106.91 9.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "9.73 153.65 26.96 151.17 26.96 251.26 9.73 251.26 9.73 153.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M15.12,152.96v-12.85l53.24-8.37v13l-16.18,2.5-25.73,3.97-11.33,1.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M35.49,136.93c0-9.78,0-9.44,0-9.44l32.87-6.13v10.38l-32.87,5.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.37,175.34v15.28l-12.13,1.13v-15.61l12.13-.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M26.86,205.15h13.28s0,.11,.01,.32c.07,4.08-.01,45.8-.01,45.8h-13.28v-46.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "26.86 151.17 52.27 147.11 52.37 161.33 26.86 164.23 26.86 151.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "40.17 205.15 40.17 251.26 52.33 251.26 52.33 205.15 52.62 205.15 52.33 205.15 68.07 205.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "52.37 147.11 68.36 144.64 68.07 251.26 52.37 251.26 52.37 147.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M52.53,161.33l-.1,14.01-12.21,.79v15.61l28.01-2.46v15.86H26.85v-40.91l12.24-1.48-12.24,1.48,25.67-2.9h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M68.07,196.6c.15,0-.29,0-.15,0s.31-7.28,.31-7.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "68.36 121.36 94.78 124.08 94.78 133.4 68.36 131.74 68.36 121.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "94.78 145.66 94.78 160.77 89.56 160.77 81.05 160.77 81.05 145.66 94.78 145.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.76,160.77v14.64l5.02-.06v-14.57h-5.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "89.76 175.4 81.05 175.34 81.05 160.77 89.76 160.77 89.76 175.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "81.57 175.34 89.76 218.78 81.05 218.78 81.05 175.54 89.76 175.54 89.76 218.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "94.78 175.34 94.78 218.78 89.76 218.78 89.76 175.54 94.78 175.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "81.1 205.15 94.9 205.15 94.9 189.32 81.1 189.32 81.1 145.66 94.9 145.66 94.9 133.4 68.35 131.74 68.35 251.26 81.62 251.26 81.1 205.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "81.05 218.78 94.78 218.78 94.78 251.72 81.57 251.72 81.05 218.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "94.78 133.4 106.78 134.33 106.78 146.55 94.78 145.9 94.78 133.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "94.78 124.08 101.17 125.11 101.17 133.95 94.78 133.37 94.78 124.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "94.78 145.66 106.78 146.39 106.78 251.72 94.78 251.72 94.78 145.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 94.8,
    y: 189.32,
    width: 11.97,
    height: 15.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "106.91 9.06 140.49 0 140.49 36.26 124.66 39.57 124.66 177.16 140.49 175.34 140.49 209.83 124.86 212.3 124.86 223.84 140.49 222.19 140.49 251.26 106.78 251.26 106.91 9.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M106.75,189.32h17.9v15.83h-17.9v-15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M140.49,35.41V175.28l-15.83,1.83V38.35l15.83-2.95h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "140.49 175.28 140.49 251.72 151.72 251.72 151.72 231.24 151.72 174.81 140.49 175.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M151.72,174.81c.07-.01,0,11.93,0,11.93h7.15v-12.48l-7.15,.55h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "158.44 174.26 167.29 172.88 167.29 251.72 158.44 251.72 158.44 174.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "124.86 212.3 140.49 210.75 140.49 206.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "151.72 187.57 158.87 186.73 151.72 186.73 151.72 187.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "140.49 175.28 167.29 172.48 167.29 177.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "167.29 172.49 184.27 170.26 184.27 251.72 167.29 251.72 167.29 172.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "151.72 187.57 158.44 186.78 158.44 251.72 151.72 251.72 151.72 187.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "124.86 212.3 184.27 206.42 184.27 218.94 124.86 223.84 124.86 212.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "140.49 0 184.08 0 184.08 15.34 172.52 15.34 172.52 35.41 160.12 35.41 160.12 15.34 152.52 15.34 151.67 21.45 151.67 27.89 151.67 35.41 140.49 35.41 140.49 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 172.2,
    y: 15.06,
    width: 11.89,
    height: 20.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 172.2,
    y: 35.41,
    width: 11.89,
    height: 48.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "184.08 83.66 184.08 170.41 172.2 171.93 172.2 83.66 184.08 83.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "152.4 35.41 151.27 35.41 150.95 15.06 152.4 15.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 150.78,
    y: 14.32,
    width: 1.87,
    height: 21.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 152.4,
    y: 15.06,
    width: 8.09,
    height: 20.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "152.4 35.41 160.49 35.41 160.49 173.28 152.4 174.01 152.4 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "140.49 35.41 152.4 35.41 152.4 174.01 140.49 175.28 140.49 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "160.49 35.41 172.2 35.41 172.2 159.31 160.49 168.08 160.49 35.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 184.27,
    y: 170.26,
    width: 98.43,
    height: 40.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 207.98,
    y: 190.04,
    width: 61.96,
    height: 5.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "81.5 247.01 81.5 251.72 68.07 251.72 68.35 131.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-61",
    points: "184.27 210.76 184.27 251.72 197.05 251.72 197.05 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "207.14 210.76 207.14 251.72 226.08 251.72 226.08 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "250.44 210.76 250.44 251.72 270.57 251.72 270.57 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "196.8 210.76 196.8 235.9 207.14 235.9 207.14 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "226.08 210.76 226.08 251.72 237.67 251.72 237.67 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "282.7 170.26 282.7 251.72 295.72 251.72 295.72 170.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "282.75 102.47 282.75 170.26 295.72 170.26 295.72 102.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "267.74 73.87 267.74 93.27 254.71 96.21 254.71 73.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "336.24 51.51 336.24 68.09 295.67 68.23 294.63 51.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "336.24 59.87 336.24 100.45 322.85 100.79 322.51 59.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-57",
    points: "282.92 102.47 282.92 170.26 267.63 170.26 267.63 106.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "282.75 69.22 282.92 89.31 267.63 93.33 267.63 70.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "254.49 59.43 254.49 127.22 239.43 127.22 239.43 63.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "282.7 69.13 246.96 81.32 239.7 63.21 282.92 51.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "267.63 120.06 267.63 170.26 254.7 170.26 254.7 122.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-54",
    points: "267.63 120.53 254.77 122.92 254.49 110.07 267.53 106.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "254.7 122.88 239.42 126.49 239.22 113.65 254.49 110.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-52",
    points: "254.7 122.92 254.7 170.26 239.1 170.26 239.42 126.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "271.11 210.76 271.11 251.72 282.7 251.72 282.7 210.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-56",
    points: "196.8 235.9 196.8 251.72 207.14 251.72 207.14 235.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 237.67,
    y: 210.29,
    width: 12.77,
    height: 41.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "160.49 168.08 172.2 159.31 172.2 171.93 160.49 173.28 160.49 168.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "295.72 67.53 323.17 67.53 323.17 89.23 308.8 89.23 308.8 72.83 308.8 71.81 295.72 71.81 295.72 67.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 295.72,
    y: 177.17,
    width: 12.88,
    height: 33.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.72,
    y: 102.47,
    width: 40.45,
    height: 14.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 295.72,
    y: 89.24,
    width: 40.45,
    height: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.72,
    y: 113.18,
    width: 13.49,
    height: 97.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.76,
    y: 71.76,
    width: 13.13,
    height: 17.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 322.87,
    y: 114.66,
    width: 13.3,
    height: 96.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 354.97,
    y: 138.59,
    width: 10.28,
    height: 57.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 354.5,
    y: 211.03,
    width: 11.12,
    height: 40.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 373.34,
    y: 154.59,
    width: 10.28,
    height: 97.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 373.34,
    y: 139.06,
    width: 10.28,
    height: 15.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 393.76,
    y: 154.59,
    width: 12.68,
    height: 97.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 405.26,
    y: 106.21,
    width: 14.96,
    height: 18.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 420.22,
    y: 146.86,
    width: 12.68,
    height: 102.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 407.77,
    y: 146.16,
    width: 12.68,
    height: 102.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 406.44,
    y: 106.21,
    width: 15.23,
    height: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 419.12,
    y: 106.21,
    width: 2.64,
    height: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 365.25,
    y: 154.59,
    width: 8.09,
    height: 97.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 383.63,
    y: 154.59,
    width: 10.13,
    height: 97.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 354.97,
    y: 195.65,
    width: 10.28,
    height: 15.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "365.25 224.28 354.97 235.45 354.97 211.03 365.25 211.03 365.25 224.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "365.25 211.03 354.97 222.08 354.97 211.03 365.25 211.03 365.25 211.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 282.92,
    y: 51.51,
    width: 12.84,
    height: 37.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 309.21,
    y: 117.06,
    width: 13.3,
    height: 93.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.72,
    y: 128.41,
    width: 40.28,
    height: 13.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.81,
    y: 194.5,
    width: 40.36,
    height: 16.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295.74,
    y: 211.03,
    width: 40.5,
    height: 13.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 336.24,
    y: 195.65,
    width: 18.73,
    height: 15.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 336.24,
    y: 153.97,
    width: 6.14,
    height: 41.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 336.24,
    y: 138.78,
    width: 6.14,
    height: 15.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 342.13,
    y: 138.78,
    width: 12.83,
    height: 15.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 365.25,
    y: 138.59,
    width: 8.09,
    height: 16.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 383.62,
    y: 95.14,
    width: 10.14,
    height: 59.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 342.13,
    y: 153.33,
    width: 12.83,
    height: 42.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 406.44,
    y: 130.3,
    width: 15.23,
    height: 66.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 421.68,
    y: 130.3,
    width: 12.85,
    height: 66.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 421.72,
    y: 92.08,
    width: 12.77,
    height: 38.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 393.76,
    y: 92.08,
    width: 12.68,
    height: 62.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 393.76,
    y: 92.08,
    width: 40.77,
    height: 14.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 393.76,
    y: 123.34,
    width: 40.77,
    height: 6.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 421.68,
    y: 196.85,
    width: 12.85,
    height: 54.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 406.44,
    y: 196.85,
    width: 15.23,
    height: 14.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 406.44,
    y: 211.03,
    width: 15.23,
    height: 40.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "354.97 139.06 336.24 139.06 336.24 110.49 354.97 105.57 354.97 139.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "393.76 139.06 348.01 139.06 348.01 107.84 393.76 102.47 393.76 139.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "393.76 113.27 336.24 113.27 336.24 107.49 393.76 92.08 393.76 113.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295.74,
    y: 223.16,
    width: 12.86,
    height: 13.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 336.24,
    y: 211.03,
    width: 18.73,
    height: 40.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295.74,
    y: 236.49,
    width: 12.86,
    height: 15.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 308.6,
    y: 236.49,
    width: 27.64,
    height: 14.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 323.32,
    y: 223.16,
    width: 12.86,
    height: 13.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 308.6,
    y: 224.36,
    width: 14.72,
    height: 12.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 295.81,
    y: 165.67,
    width: 40.36,
    height: 14.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 184.27,
    y: 41.65,
    width: 13.23,
    height: 42.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 184.27,
    width: 13.23,
    height: 41.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 213.42,
    width: 13.62,
    height: 70.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "239.43 170.26 226.61 170.26 227.04 83.66 239.43 74.55 239.43 170.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 197.5,
    width: 16.97,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 197.5,
    y: 41.65,
    width: 15.92,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 197.59,
    y: 20.69,
    width: 16.19,
    height: 20.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 204.38,
    y: 55.85,
    width: 9.04,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 197.5,
    y: 55.85,
    width: 6.9,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 197.5,
    y: 70.41,
    width: 16.28,
    height: 13.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "207.24 97.43 184.08 113.79 184.08 83.66 227.04 83.66 207.24 97.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 210.76,
    y: 70.41,
    width: 16.28,
    height: 13.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.61 170.26 195.88 170.26 195.88 105.34 227.04 83.66 226.61 170.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "196.15 169.98 184.04 169.98 184.04 113.79 195.88 105.34 196.15 169.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "282.92 89.31 254.5 96.21 254.49 110.07 282.92 102.67 282.92 89.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 282.86,
    y: 89.23,
    width: 12.9,
    height: 13.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviherLogo);
export default __webpack_public_path__ + "static/media/moviher-logo.9c47959f35c551c9bfd9f8a258264f8d.svg";
export { ForwardRef as ReactComponent };